const { DateTime } = require("luxon");

interface IPasswordCheck {
  ( password: string,
    confirmPassword: string
  ): Promise<boolean>
}

const comparePasswords: IPasswordCheck = (password, confirmPassword) => {
  return new Promise<boolean>((resolve, reject) => {
    if(password != confirmPassword) {
      throw new Error('Passwords do not match');
    }
    resolve(true);
  });
}

/**
 * Function to get URL parameters
 * 
 * @param {string} param the name of the parameter being queried.
 * 
 * @returns string
 */
const getParameters = (param: string): string => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const parameter = urlParams.get(param)!;

  return parameter;
}

/**
 * Generator function to get a unique value
 */
function* generator() {
  let index = 1;
  while(true) {
    yield index++;
  }
}

/**
 * Function helps to expand the filter selction on click.
 * 
 * @param {string} elementName the css class of the element
 * 
 * @returns void
 */
const dropIcon = (elementName: string) => {
  let parent = document.querySelector(elementName) as HTMLElement;
  if(!parent) return;
  parent.addEventListener('click', () => {
    let arrow = parent.querySelector('.arrow') as HTMLElement;
    arrow.classList.toggle('active')
  });
}

/**
 * Function to format the date
 * 
 * @param {string} date the date time from mysql
 * 
 * @returns string
 */
const formatDate = (date: string): string => {  
  let d = new Date(date);
  let offset = d.getTimezoneOffset();
  let local = new Date(d.getTime() + offset * 60000);
  let month = (local.getMonth() + 1);
  let day = local.getDate();
  let year = local.getFullYear();
  let hour = local.getHours();
  let minutes = String(local.getMinutes()).padStart(2, '0');
  let ampm = hour >= 12 ? 'pm' : 'am';
  hour = (hour % 12) || 12; 

  return `${month}-${day}-${year} ${hour}:${minutes} ${ampm}`;
}

export { comparePasswords, getParameters, generator, dropIcon, formatDate };